import * as React from "react";
import { Form, Input } from "antd";
import { EmailSelect } from "../../../../common";
const FormItem = Form.Item;

export default class EmailOption extends React.Component<any, {}> {
  render() {
    const {
      option,
      disabled,
      form,
      recipiants,
      subject,
      getFieldValue,
      handleChange
    } = this.props;

    return (
      <div className="emails right">
        <EmailSelect
          value={recipiants}
          handleChange={handleChange}
          disabled={disabled}
          tokenSeparators={[" ", ","]}
          placeholder="To :"
          form={form}
          name="recipiants"
          form_value_key={`${option}.endpoint`}
          label="Recipient Email Address(s)"
        />
        <FormItem label="Subject:" hasFeedback={!disabled}>
          {this.props.form.getFieldDecorator(`${option}.subject`, {
            rules: [
              {
                min: 1,
                max: 999,
                message: "Please enter an email subject."
              }
            ],
            initialValue: subject
          })(
            <Input
              className="form-length"
              name="subject"
              onChange={this.props.handleChange}
              placeholder="Subject : Flipp Data Delivery"
              disabled={disabled}
            />
          )}
        </FormItem>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportEndpoint/email.tsx